import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { requestPasswordReset } from "../../services/authService";
import "../welcome/welcome.scss";

function ForgotPassword() {
  const [searchParams] = useSearchParams();
  const fromDeveloper = searchParams.get("from") === "developer";
  const signInPath = fromDeveloper ? "/developer/signin" : "/";
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus("");
    try {
      const result = await requestPasswordReset(email);
      setStatus(result.message || "If an account exists for that email, we sent a reset link.");
    } catch (error) {
      setStatus("If an account exists for that email, we sent a reset link.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modern-welcome-container">
      <div className="background-elements">
        <div className="bg-element bg-element-1"></div>
        <div className="bg-element bg-element-2"></div>
        <div className="bg-element bg-element-3"></div>
      </div>
      <div className="main-content">
        <div className="content-wrapper">
          <div className="welcome-card">
            <div className="card-background"></div>
            <div className="card-header">
              <h1 className="card-title">Reset password</h1>
              <p className="card-subtitle">We'll email a reset link if that account exists.</p>
            </div>
            <div className="card-content">
              <form onSubmit={handleSubmit} style={{ marginBottom: "1.5rem" }}>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Email"
                  disabled={loading}
                  required
                  style={{
                    width: "100%",
                    padding: "0.75rem 1rem",
                    borderRadius: "0.5rem",
                    border: "1px solid rgba(255, 255, 255, 0.2)",
                    background: "rgba(255, 255, 255, 0.08)",
                    color: "white",
                    marginBottom: "0.75rem",
                  }}
                />
                <button type="submit" disabled={loading} className="google-signin-btn" style={{ marginBottom: 0 }}>
                  <div className="btn-background"></div>
                  <div className="btn-content">{loading ? "Sending..." : "Send reset link"}</div>
                </button>
              </form>
              {status && (
                <p style={{ color: "#d8b4fe", fontSize: "0.875rem", marginBottom: "1rem", textAlign: "center" }}>
                  {status}
                </p>
              )}
              <div style={{ textAlign: "center" }}>
                <Link to={signInPath} style={{ color: "#e879f9", textDecoration: "none", fontSize: "0.875rem" }}>
                  Back to sign in
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
